(function () {
  'use strict';

  // Remembers, in this browser, that the welcome code has already been shown.
  var CLAIM_KEY = 'spindleWelcomeClaimed';

  function hasClaimed() {
    try {
      if (window.localStorage.getItem(CLAIM_KEY) === '1') return true;
    } catch (e) {}
    return document.cookie.split('; ').indexOf(CLAIM_KEY + '=1') !== -1;
  }

  function markClaimed() {
    try {
      window.localStorage.setItem(CLAIM_KEY, '1');
    } catch (e) {}
    try {
      document.cookie = CLAIM_KEY + '=1; max-age=31536000; path=/; SameSite=Lax';
    } catch (e) {}
  }

  function initSpindleGame(root) {
    var stage = root.querySelector('[data-spindle-stage]');
    var dog = root.querySelector('[data-spindle-dog]');
    var stones = Array.prototype.slice.call(root.querySelectorAll('[data-spindle-stone]'));
    var progressEl = root.querySelector('[data-spindle-progress]');
    var skipLink = root.querySelector('[data-spindle-skip]');
    var modal = document.querySelector('[data-spindle-modal]');
    if (!stage || !dog || !stones.length || !modal) return;

    var storeMarker = stage.querySelector('.spindle-game__marker--store');
    var current = -1;
    var completed = false;

    // Returning winners can still play, but the popup no longer shows the code.
    function applyClaimedState() {
      var heading = modal.querySelector('[data-spindle-heading]');
      var codeWrap = modal.querySelector('[data-spindle-code-wrap]');
      var claimedBox = modal.querySelector('[data-spindle-claimed]');
      if (heading && heading.getAttribute('data-claimed-heading')) {
        heading.textContent = heading.getAttribute('data-claimed-heading');
      }
      if (codeWrap && codeWrap.parentNode) codeWrap.parentNode.removeChild(codeWrap);
      if (claimedBox) claimedBox.hidden = false;
    }

    var alreadyClaimed = hasClaimed();
    if (alreadyClaimed) applyClaimedState();

    stones.sort(function (a, b) {
      return parseInt(a.getAttribute('data-index'), 10) - parseInt(b.getAttribute('data-index'), 10);
    });

    function setNextHighlight() {
      stones.forEach(function (stone, i) {
        stone.classList.toggle('is-next', i === current + 1 && !completed);
      });
    }

    function updateProgress() {
      if (completed) {
        progressEl.textContent = "Yay, they made it home to Spindle!";
        return;
      }
      if (current === -1) {
        progressEl.textContent = 'Tap the first paw print to start';
      } else {
        progressEl.textContent = (current + 1) + ' of ' + stones.length + ' paw prints — keep going!';
      }
    }

    function moveDogTo(el) {
      var left = el.style.left;
      var top = el.style.top;
      dog.style.left = left;
      dog.style.top = top;
      dog.classList.remove('is-hopping');
      // force reflow so the animation can restart
      void dog.offsetWidth;
      dog.classList.add('is-hopping');
    }

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var card = modal.querySelector('.spindle-modal__card');
      if (card) card.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    function arriveAtStore() {
      completed = true;
      moveDogTo(storeMarker);
      updateProgress();
      setNextHighlight();
      // First win in this browser: show the code now, remember it for next time.
      if (!alreadyClaimed) markClaimed();
      window.setTimeout(openModal, 650);
    }

    stones.forEach(function (stone, index) {
      stone.addEventListener('click', function () {
        if (completed) return;
        if (index === current + 1) {
          current = index;
          stone.classList.add('is-visited');
          moveDogTo(stone);
          updateProgress();
          setNextHighlight();
          if (current === stones.length - 1) {
            window.setTimeout(arriveAtStore, 550);
          }
        } else if (index > current + 1) {
          stone.classList.remove('is-shake');
          void stone.offsetWidth;
          stone.classList.add('is-shake');
        }
      });
    });

    if (skipLink) {
      skipLink.addEventListener('click', function (e) {
        var target = document.getElementById('spindle-shop');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    modal.querySelectorAll('[data-spindle-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    var shopBtn = modal.querySelector('[data-spindle-modal-shop]');
    if (shopBtn) {
      shopBtn.addEventListener('click', function (e) {
        var target = document.getElementById('spindle-shop');
        if (target) {
          e.preventDefault();
          closeModal();
          window.setTimeout(function () {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    var copyBtn = modal.querySelector('[data-spindle-copy]');
    var codeEl = modal.querySelector('[data-spindle-code]');
    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var text = codeEl.textContent.trim();
        var done = function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copied!';
          window.setTimeout(function () {
            copyBtn.textContent = original;
          }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, done);
        } else {
          var range = document.createRange();
          range.selectNode(codeEl);
          window.getSelection().removeAllRanges();
          window.getSelection().addRange(range);
          document.execCommand('copy');
          window.getSelection().removeAllRanges();
          done();
        }
      });
    }

    updateProgress();
    setNextHighlight();
  }

  function init() {
    document.querySelectorAll('[data-spindle-game]').forEach(initSpindleGame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
